"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectBreakpoint = void 0;
var detectBreakpoint = function (breakpoint) {
    switch (breakpoint) {
        case 0 /* Breakpoint.Mobile */:
            return window.innerWidth <= 480;
        case 1 /* Breakpoint.DownToMobile */:
            return window.innerWidth >= 480;
        case 2 /* Breakpoint.Tablet */:
            return window.innerWidth <= 768;
        case 3 /* Breakpoint.UpToTablet */:
            return window.innerWidth < 768;
        case 4 /* Breakpoint.DownToTablet */:
            return window.innerWidth >= 768;
        case 5 /* Breakpoint.MDSscreen */:
            return window.innerWidth <= 1200;
        case 6 /* Breakpoint.SMScreen */:
            return window.innerWidth < 992;
        case 7 /* Breakpoint.LGScreen */:
            return window.innerWidth >= 992;
        default:
            return false;
    }
};
exports.detectBreakpoint = detectBreakpoint;
